import { FullStory } from '@fullstory/browser';

/**
 * Gets the current FullStory session ID with timestamp for RUM observability
 * @returns FullStory session ID with timestamp (e.g., "uuid:uuid:timestamp"), or undefined if FullStory is not available
 */
export const getFullStorySessionId = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  try {
    const sessionUrl = FullStory('getSession', { format: 'url.now' });
    if (!sessionUrl) {
      return undefined;
    }

    // Extract session ID from URL like:
    // https://app.fullstory.com/ui/o-1VHTDK-na1/client-session/567b1a43-0024-42a4-878d-cc524e482b69%3A64c41626-5f03-4e1d-a9cb-0d076880eba6%3A1778770003460
    const match = sessionUrl.match(/\/client-session\/([^/?#]+)/);
    if (!match || !match[1]) {
      return undefined;
    }

    // Decode URL-encoded session ID (e.g., %3A -> :)
    return decodeURIComponent(match[1]);
  } catch (error) {
    return undefined;
  }
};
